import { isAxiosError } from "axios";
import { type IShowSnack } from "@/stores/snack";

export type DjangoRestFrameworkErrorType = Partial<
  Record<
    "non_field_errors" | "detail" | "code" | string,
    string | string[] | DjangoRestFrameworkErrorType[]
  >
>;

interface ISnackable {
  showSnack: (showSnack: IShowSnack) => void;
}

function convertErrorFields(data: DjangoRestFrameworkErrorType): Record<string, string[]> {
  const errors: Record<string, string[]> = {};

  function convertErrorFieldsRec(d: DjangoRestFrameworkErrorType, keyPrefix: string = "") {
    for (const r in d) {
      const errkey = keyPrefix ? `${keyPrefix}.${r}` : r;
      const v = d[r];
      if (typeof v === "string") {
        errors[errkey] = [v];
      } else if (Array.isArray(v)) {
        if (v.length == 0) {
          // do nothing
          continue;
        } else if (typeof v[0] === "string") {
          errors[errkey] = v as string[];
        } else {
          v.forEach((item, index) => {
            convertErrorFieldsRec(item as DjangoRestFrameworkErrorType, `${errkey}[${index}]`);
          });
        }
      }
    }
  }
  convertErrorFieldsRec(data);
  return errors;
}

export function djangoErrorHandler(
  setErrors: (fields: Partial<Record<string, string | string[] | undefined>>) => void,
  snackStore: ISnackable
) {
  return function (error: any) {
    if (
      isAxiosError<DjangoRestFrameworkErrorType>(error) &&
      error.response?.status == 400 &&
      error.response?.data
    ) {
      console.warn(error.response.data);
      const errors = convertErrorFields(error.response.data);
      setErrors(errors);
    } else {
      snackStore.showSnack(<IShowSnack>{
        message: error,
        timeout: 3000,
        color: "error",
      });
    }
  };
}

export function convertErrorsToHtmlString(errors: any) {
  let htmlString = '';
  for (const key in errors) {
    if (errors.hasOwnProperty(key)) {
      let error = errors[key];
      if (Array.isArray(error)) {
        error = error.join(', ');
      } else {
        error = error.toString();
      }
      htmlString += `<strong>${key}</strong>: ${error}<br>`;
    }
  }
  return htmlString;
}